// extracted by mini-css-extract-plugin
export default {"shortcut":"I8rxXoL5L+4P0pw9O5SioA=="};